module.exports = function() {

  /**
   *  Validates a boolean.
   *
   *  @param cb The callback function.
   */
  this.main.boolean = function bool(cb) {
    if(this.validates()) {
      this.required();
      this.type();
    }
    cb();
  }

}



//////////////////
// WEBPACK FOOTER
// ../node_modules/async-validate/plugin/boolean.js
// module id = 1370
// module chunks = 93